<header class="main__content__header modal-header">
  <h2 class="modal-title">Detalhe Contribuição</h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <section class="modal__main__dados_usuario content__modal__header">
    <div class="pl-0 pr-0 mb-3 row">
      <div class="col-12 mb-1">
        <span class="content__modal__title">Data do Pagamento</span>
        <p class="content__modal__valor">{{details.paymentDate | date:'dd/MM/yyyy'}}</p>
      </div>
      <div class="col-sm-12 col-xl-4">
        <span class="content__modal__title">Contribuição Normal</span>
        <p class="content__modal__valor">{{details.normalContribution | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
      <div class="col-sm-12 col-xl-4">
        <span class="content__modal__title">Contribuição Facultativa</span>
        <p class="content__modal__valor">{{details.extraContribution | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
      <div class="col-sm-12 col-xl-4">
        <span class="content__modal__title">Custo Administrativo</span>
        <p class="content__modal__valor">{{details.administrativeCost | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
    </div>
    <div class="col-12 mb-3 pl-0 pr-0 row">
      <div class="col-4">
        <span class="content__modal__title">Valor Pago</span>
        <p class="content__modal__valor">{{details.total | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
      <div class="col-4">
        <span class="content__modal__title">Cotas Adquiridas</span>
        <p class="content__modal__valor">{{details.quotasAcquired | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
      <div class="col-4">
        <span class="content__modal__title">Benefício de Risco</span>
        <p class="content__modal__valor">{{details.riskBenefit | currency:'BRL':'symbol':'1.2-2':'pt'}}</p>
      </div>
    </div>
  </section>
</main>